import { styled } from "goober";
import type { ReactNode } from "react";
import { Icon } from "./Icon";
import { Text } from "./Text";

const Container = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 40px;
  padding: 6px 8px 6px 12px;
  box-sizing: border-box;
  background: var(--orange-200);
  border: 0.5px solid var(--orange-400);
  border-radius: 12px;
  gap: 12px;
`;

const Content = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

const Actions = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export function Banner({
  children,
  actions,
}: {
  children: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <Container>
      <Content>
        <Icon name="info" size={16} color="var(--orange-1000)" />
        <Text variant="text-regular" color="var(--orange-1000)">
          {children}
        </Text>
      </Content>
      {actions && <Actions>{actions}</Actions>}
    </Container>
  );
}
